<template>
  <div style="position:relative">
    <a-spin class="spinner" v-if="initLoading" />
    <div :class="'categories-comp '+ tabPosition">
      <a-tabs :defaultActiveKey="activeKey" :tabPosition="tabPosition" @change="onTabChange">
        <a-tab-pane v-for="(item, index) in items" :key="index" :tab="item.name"></a-tab-pane>
      </a-tabs>
      <div class="list ant-list ant-list-split" v-if="items.length">
        <div class="ant-spin-nested-loading">
          <div class="ant-spin-container">
            <div
              class="ant-list-item"
              v-for="(item,index) in items[activeKey].subcategories"
              :key="index"
            >
              <div class="ant-list-item-meta">
                <div class="ant-list-item-meta-avatar">
                  <span
                    class="ant-avatar ant-avatar-circle ant-avatar-image"
                    :style="{ backgroundColor: items[activeKey].color}"
                  >
                    <svg class="ico">
                      <use :xlink:href="'#'+item.icon" />
                    </svg>
                  </span>
                </div>
                <div class="ant-list-item-meta-content">
                  <h4 class="ant-list-item-meta-title">
                    <h3 v-if="!item.isEditmode" slot="title">{{item.name}}</h3>
                    <a-input
                      v-if="item.isEditmode"
                      :defaultValue="item.name"
                      @change="onTextChange(item,$event.target.value, index)"
                      @pressEnter="onSave(item,index)"
                    />
                  </h4>
                </div>
              </div>
              <ul v-if="item.isEditmode" class="ant-list-item-action">
                <li>
                  <a-button
                    v-if="tabPosition === 'top'"
                    @click="onSave(item,index)"
                    type="primary"
                    shape="circle"
                    icon="save"
                  ></a-button>
                  <a-button
                    v-if="tabPosition === 'left'"
                    @click="onSave(item,index)"
                    type="primary"
                    icon="save"
                  >{{$t('save')}}</a-button>
                </li>
                <li>
                  <a-button v-if="tabPosition === 'top'" @click="onCancel(item,index)" icon="close"></a-button>
                  <a-button
                    v-if="tabPosition === 'left'"
                    @click="onCancel(item,index)"
                    icon="close"
                  >{{$t('cancel')}}</a-button>
                </li>
              </ul>
              <ul v-if="!item.isEditmode" class="ant-list-item-action">
                <li>
                  <a-button
                    v-if="tabPosition === 'top'"
                    @click="onEdit(item,index)"
                    type="primary"
                    icon="edit"
                  ></a-button>
                  <a-button
                    v-if="tabPosition === 'left'"
                    @click="onEdit(item,index)"
                    type="primary"
                    icon="edit"
                  >{{$t('edit')}}</a-button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-row">
      <a-button
        @click="onSubmit()"
        type="primary"
        icon="save"
        :loading="processing"
        :disabled="disabled"
      >{{$t('submit-changes')}}</a-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { colors, categories, subCategories } from "../configs.js";
import { CATEGORIES, USER_INFO } from "../store/constants";

import fb from "../firebaseConfig.js";
export default {
  name: "Categories",
  data() {
    return {
      initLoading: true,
      processing: false,
      tabPosition: null,
      activeKey: 0,
      disabled: true,
      items: []
    };
  },
  computed: {
    ...mapState({
      categories: state => {
        return state.categories[CATEGORIES].map(category => {
          return {
            name: category.name,
            id: category.id,
            color: colors[category.color],
            subcategories: category.subcategories.map(subcategory => ({
              icon: subcategory.icon,
              id: subcategory.id,
              parentId: subcategory.parentId,
              name: subcategory.name,
              isEditmode: false
            }))
          };
        });
      },
      user: state => state.auth[USER_INFO]
    })
  },
  watch: {
    categories(newV, oldV) {
      this.items = [...this.categories];
    }
  },
  methods: {
    ...mapActions({
      getCategories: "categories/getCategories",
      updateCategories: "categories/updateCategories"
    }),
    onSubmit() {
      this.processing = true;
      this.updateCategories(this.items)
        .then(() => (this.processing = false))
        .catch(() => (this.processing = false));
    },
    onSave(d, index) {
      this.disabled = false;
      this.items = this.items.map(category => {
        return {
          name: category.name,
          id: category.id,
          color: category.color,
          subcategories: category.subcategories.map(subcategory => {
            if (d.id === subcategory.id) {
              return {
                ...subcategory,
                isEditmode: false
              };
            } else {
              return subcategory;
            }
          })
        };
      });
    },
    onCancel(d, index) {
      this.items = this.items.map(category => {
        return {
          name: category.name,
          id: category.id,
          color: category.color,
          subcategories: category.subcategories.map(subcategory => {
            if (d.id === subcategory.id) {
              return {
                ...subcategory,
                name: subcategory.oldName,
                oldName: null,
                isEditmode: false
              };
            } else {
              return subcategory;
            }
          })
        };
      });
    },
    onTextChange(d, value, index) {
      this.items = this.items.map(category => {
        return {
          name: category.name,
          id: category.id,
          color: category.color,
          subcategories: category.subcategories.map(subcategory => {
            if (d.id === subcategory.id) {
              return {
                ...subcategory,
                name: value
              };
            } else {
              return subcategory;
            }
          })
        };
      });
    },
    onEdit(d, index) {
      this.items = this.items.map(category => {
        return {
          name: category.name,
          id: category.id,
          color: category.color,
          subcategories: category.subcategories.map(subcategory => {
            if (d.id === subcategory.id) {
              return {
                ...subcategory,
                oldName: subcategory.name,
                isEditmode: true
              };
            } else {
              return subcategory;
            }
          })
        };
      });
    },
    onTabChange(key) {
      this.activeKey = key;
    }
  },
  mounted() {
    this.tabPosition = window.innerWidth > 640 ? "left" : "top";
    this.initLoading = true;
    this.getCategories()
      .then(() => (this.initLoading = false))
      .catch(() => (this.initLoading = false));
  }
};
</script>

<style scoped lang="less">
@import "../styles/variables.less";
.categories-comp.top {
  background: #f0f2f5;
  padding: 8px 16px;
  border-radius: 16px;
  border-radius: 0px 16px 16px 16px;
  margin-top: -30px;
}
.categories-comp.left {
  display: flex;
  justify-content: space-between;
  margin-top: -32px;
  background: #f0f2f5;
  border: solid 1px #e8e8e8;
  padding-top: 16px;
  border-radius: 0px 16px 16px 16px;
}
.list {
  flex: 1;
}
.ant-avatar {
  display: flex;
  font-size: 24px;
  border-radius: 50%;
  padding: 4px;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
}
h3 {
  margin-top: 6px;
}
.button-row {
  width: 100%;
  text-align: right;
  margin-top: @spacing;
}
.spinner {
  position: absolute;
  top: -28px;
  right: 10px;
}
</style>
